import React from 'react';
import PublicPage from '../cms/PublicPage';

export default function SportsCoCurricularPage() {
  return <PublicPage slug="sports-co-curricular" />;
}
